module.exports = __webpack_public_path__ + "static/media/react-static.2784aa58.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-alternatives/images/react-static.png
// module id = 965
// module chunks = 0